import { render } from "./HaiPhong.vue?vue&type=template&id=62ce7dba"
import script from "./HaiPhong.vue?vue&type=script&lang=js"
export * from "./HaiPhong.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__